import { MatOptionModule } from '@angular/material/core';
import { element } from 'protractor';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation, ViewChildren,QueryList   } from '@angular/core';

import { FormBuilder, FormGroup } from '@angular/forms';

import { NgxSpinnerService } from 'ngx-spinner';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import { environment } from '../../../environments/environment';
import { IEdificios } from '../interfaces/Edificios';
import { IMarcas } from '../interfaces/Marcas';

import { VentaMarcaChartComponent } from './venta-marca-chart/venta-marca-chart.component';
import { IFiltrosConsultaCharts } from '../interfaces/FiltrosConsulta';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { NgbdDatepickerRange } from '../../utilities/datepickerrange/datepicker-range';
import { registerLocaleData } from '@angular/common';
import localeCO from '@angular/common/locales/es-CO';

import {Sort} from '@angular/material/sort';
import { exit } from 'process';

import Swal from 'sweetalert2';

// the second parameter 'fr-FR' is optional
registerLocaleData(localeCO, 'es-CO');

@Component({

  selector: 'app-reporte-ventas-marcas',
  templateUrl: './reporte-ventas-marcas.component.html',
  styleUrls: ['./reporte-ventas-marcas.component.scss'],
  encapsulation: ViewEncapsulation.None,
  
})
export class ReporteVentasMarcasComponent implements OnInit {
  @ViewChild('chartMarcasComp') myChart: VentaMarcaChartComponent;
  //@ViewChild('chartVariacion') myChartVariacion: VentaMarcaChartComponent;
  @ViewChild('chartTicket') myChartTicket: VentaMarcaChartComponent;
  @ViewChild('chartCompliance') myChartCompliance: VentaMarcaChartComponent;
  @ViewChild('chartTasa') myChartTasa: VentaMarcaChartComponent;
  @ViewChild('chartVariacionFinal') myChartVariacionFinal: VentaMarcaChartComponent;
  @ViewChild('chartVariacionTrafico') myChartVariacionTrafico: VentaMarcaChartComponent;
  @ViewChild('chartVariacionTraficosemanalmes') myChartVariacionTraficoSemanalMes: VentaMarcaChartComponent;
  @ViewChild('chartVariacionTraficosdiasxmes') myChartVariacionTraficosdiasxmes: VentaMarcaChartComponent;

  @ViewChild('chartPesoTraficodiasxmes') mychartPesoTraficodiasxmes: VentaMarcaChartComponent;
  @ViewChild('chartPesoTraficosemanalxmes') mychartPesoTraficosemanalxmes: VentaMarcaChartComponent;
  @ViewChild('chartPesoCCEntradasXMes') mychartPesoCCEntradasXMes: VentaMarcaChartComponent;
  
  //@ViewChild(MatSort, {static: true}) sort: MatSort;

  @ViewChild('embeddedReport') embeddedReport: ElementRef;
  @ViewChild('dateAnt') dateAnt: NgbdDatepickerRange;
  @ViewChild('dateAct') dateAct: NgbdDatepickerRange;
  @ViewChild('itemsDiv', { read: ElementRef }) public itemsContent: ElementRef<any>;

  @ViewChild("typeChart") blockTypeChart: ElementRef;
  @ViewChild("ComparativoChart") blockComparativoChart: ElementRef;


  @ViewChild("_dateEndAct") _dateEndAct: ElementRef;
  @ViewChild("_dateEndAnt") _dateEndAnt: ElementRef;

  name = 'Angular';
  modelDate = '';
  taficomesseleccionado = '';
  taficomesseleccionadosemanas = '';

  config: any;
  screenHeight: number;
  edificios: Array<IEdificios>;
  marcas: Array<IMarcas>
  formReporte: FormGroup;
  KPIs: any[];
  filtros: IFiltrosConsultaCharts;
  result: any = {datasetPesoCCEntradasXMes:[], datasetPesoGrupoSemanaXMes:[], datasetPesoCCxSemanaFinSemanaXMes:[],datasetResumenVentas:[], datasetResumenVariacion:[],datasetResumenMT2:[],datasetResumenTasa:[],datasetVariacionVentasXTrafico:[],datasetVariacionTraficoSemanalXMes:[],datasetVariacionTraficoDiasXMes:[],datasetTicketAverage:[],datasetCumplimiento:[],datasetTasa:[],datasetVariacion:[],datasetTable:[],datasetTableCC:[],datasetTableMarca:[],datasetTableCate:[],datasetTableSubCate:[]};
  dataset: any;
  model = 1;
  buildsSelect:string[] = [];
  marcasSelect:string[] = [];

  actDateFrom: NgbDate | null;
  actDateTo: NgbDate | null;
  antDateFrom: NgbDate | null;
  antDateTo: NgbDate | null;

  titleComparativo: string = "% Variación";
  titleVariacion: string = "Variación Tráfico";
  titleMarcas: string = "Ventas Marca";

  titleSemFinSem: string = "Peso Semana Fin de semana";
  titleDiasSem: string = "Peso Día Semana";
  titleEntradaMes: string = "Peso Entrada Por Mes";

  comparativeButton: number = 1;
  resumenButton: number =1;
  years: any[] = [];
  months: any[] = [];

  
  actInitDate: any;
  actEndDate: any;
  antInitDate: any;
  antEndDate: any;

  displayedColumns: string[] = ['build', 'year','month', 'variSales', 'vm2', 'ticket', 'area', 'lastSales', 'currentSales', 'budget', 'compliance'];
  sortedData: any[];
  sortedDataCC: any[];
  sortedDataMarca: any[];
  sortedDataCate: any[];
  sortedDataSubCate: any[];
  tabActive:number = 1;
  activeCeco:string = '';
  Cecos: any[] = [];
  isCCShown = false;
  isMarcaShown = false;
  isCategoriaShown = false;
  isSubcategoriaShown = false;
  isComparativoShown=false;
  istraficoShown=false;

  lsGeneralInfoisLoaded= false;

  // OutActDateFrom: NgbDate | null;
  // OutActDateTo: NgbDate | null;
  // OutAntDateFrom: NgbDate | null;
  // OutAntDateTo: NgbDate | null;

  constructor(private httpClient: HttpClient,
    private spinner: NgxSpinnerService,
    private readonly formBuilder: FormBuilder,
    private calendar: NgbCalendar,
    private registroServicios: RegistroVentasService,
    private element: ElementRef,
    ) { 
    //Object.assign(this, { KPIs });
    this.actDateFrom =  calendar.getNext(calendar.getToday(), 'd', -30);
    this.actDateTo = calendar.getToday(); 
    this.antDateFrom = calendar.getNext(this.actDateFrom, 'y', -1);
    this.antDateTo = calendar.getNext(this.actDateTo, 'y', -1);
    
    this.actInitDate = calendar.getToday().year.toString() + "-" + calendar.getToday().month.toString();
    this.actEndDate = calendar.getToday().year.toString() + "-" + calendar.getToday().month.toString();
    this.antInitDate = calendar.getNext(calendar.getToday(), 'y', -1).year.toString() + "-" + calendar.getToday().month.toString();
    this.antEndDate = calendar.getNext(calendar.getToday(), 'y', -1).year.toString()  + "-" + calendar.getToday().month.toString();
    
    
  }

  updateCalendaBeforedates(newdate){

   debugger;
   //this.antInitDate = thicalendar.getNext(calendar.getToday(), 'y', -1).year.toString() + "-" + calendar.getNext(calendar.getToday(), 'y', -1).month.toString();
   // this.antEndDate = calendar.getNext(calendar.getToday(), 'y', -1).year.toString()  + "-" + calendar.getNext(calendar.getToday(), 'y', -1).month.toString();
 
  }


  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };     
    container.setViewMode('month');
  }


  ngOnInit() {
    
    this.construirFromularioReporte();
    this.getEdificiosConsulta(environment.edificiosAutorizados, environment.marcasAutorizadas);
    this.getMarcasConsulta(environment.marcasAutorizadas =="" ? [] : environment.marcasAutorizadas .split(","));

    //localStorage.setItem('DSGeneralInfo', null);
    //this.dataSource.sort = this.sort;
  }
  currencyFormated(val:number, prefix) {
    var num = '0';
    
    if(prefix == '$')
    {
      num = val.toFixed(0);
    }else{
      num = val.toFixed(2);
    }

    return num;
  }

  currencyAbreviature(val)
  {
    var num = val;
    var digits = 0;
      const lookup = [
        { value: 1, symbol: "" },
         { value: 1e3, symbol: "k" },
         { value: 1e6, symbol: "mill" },
        // { value: 1e9, symbol: "G" },
        // { value: 1e12, symbol: "T" },
        // { value: 1e15, symbol: "P" },
        // { value: 1e18, symbol: "E" }
      ];
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      var item;
      if(num < 0)
      {
        item = lookup.slice().reverse().find(function(item) {
          return (num)*-1 >= item.value;
        });
      }else{
        item = lookup.slice().reverse().find(function(item) {
          return num >= item.value;
        });
      }
      
      return  (item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0").toString();
      //num = val.toFixed(0);
    
  }
  //@HostListener("wheel", ["$event"])
  onWheel(event: WheelEvent): void {
    this.itemsContent.nativeElement.scrollLeft += event.deltaY;
    event.preventDefault();
  }
  checkBuild(build) {
    if(this.buildsSelect.indexOf(build) > -1)
    return true;
    else
    return false;
  }
  toggleSelection(buildName) {
    var idx = this.buildsSelect.indexOf(buildName);

    // Is currently selected
    if (idx > -1) {
      this.buildsSelect.splice(idx, 1);
    }

    // Is newly selected
    else {
      this.buildsSelect.push(buildName);
    }
  };
  construirFromularioReporte() {
    this.formReporte = this.formBuilder.group({
      edificio: [''],
      marca: ['']
    });
  }
  
  get f() { return this.formReporte.controls; }
  
  getEdificiosConsulta(edificios: string, marcas: string) {
    this.spinner.show();
    this.registroServicios.getEdificiosConsulta(edificios, marcas).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.edificios = resolve.sort((a,b) => a.nombre.localeCompare(b.nombre));
          
          this.buildsSelect = this.edificios.map(x=> x.codigo);
          
          this.spinner.hide();
        }
      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }

  setNewDateInitActual(event){
    this.actInitDate = new Date(event.split('-')[0], event.split('-')[1], 0);
    this.actEndDate = new Date(event.split('-')[0], event.split('-')[1], 0);
    this.antInitDate = new Date(event.split('-')[0]-1, event.split('-')[1], 0);
    this.antEndDate = new Date(event.split('-')[0]-1, event.split('-')[1], 0);
    this._dateEndAct.nativeElement.showPicker();
  }
  setNewDateEndActual(event){
    this.actEndDate = new Date(event.split('-')[0], event.split('-')[1], 0);
    this.antEndDate =  new Date(event.split('-')[0]-1, event.split('-')[1], 0);
    //this._dateEndAnt.nativeElement.showPicker();
  }

  updateDatesAct(event)
  {
    debugger;
    this.actDateFrom = event.from;
    this.actDateTo = event.to;

    this.antDateFrom = this.calendar.getNext(event.from, 'y', -1); 
    this.antDateTo = this.calendar.getNext(event.to, 'y', -1);
  }
  updateDatesAnt(event)
  {
    debugger;
    this.antDateFrom = event.from;
    this.antDateTo = event.to;
  }
  defaultResult()
  {
    this.titleMarcas = "Ventas Marca";
    this.titleComparativo = "% Variación";
    this.result = {datasetPesoCCEntradasXMes:[], datasetPesoGrupoSemanaXMes:[],datasetPesoCCxSemanaFinSemanaXMes:[], datasetResumenVentas:[], datasetResumenVariacion:[],datasetResumenMT2:[],datasetResumenTasa:[],datasetVariacionVentasXTrafico:[],datasetVariacionTraficoSemanalXMes : [],datasetVariacionTraficoDiasXMes:[],datasetTicketAverage:[],datasetCumplimiento:[],datasetTasa:[],datasetVariacion:[],datasetTable:[],datasetTableCC:[],datasetTableMarca:[],datasetTableCate:[],datasetTableSubCate:[]};
    this.sortedData = [];
    this.sortedDataCC = [];
    this.sortedDataMarca = [];
    this.sortedDataCate = [];
    this.sortedDataSubCate = [];
    this.KPIs = [];
    this.Cecos = [];
    this.tabActive = 1;
    this.activeCeco = '';
    this.myChart.updateChart(1,this.result.datasetResumenVentas,this.result.labels);
    //this.myChartVariacion.updateChart(1,this.result.datasetVariacionVentasXTrafico,this.result.labels);
    this.myChartTicket.updateChart(1,this.result.datasetTicketAverage,this.result.labels);
    this.myChartCompliance.updateChart(1,this.result.datasetCumplimiento,this.result.labels);
    this.myChartTasa.updateChart(1,this.result.datasetTasa,this.result.labels);
    this.myChartVariacionFinal.updateChart(1,this.result.datasetVariacion,this.result.labels);
  }
  getResults() {

    this.spinner.show();
    this.isCCShown = false;
    this.isMarcaShown = false;
    this.isCategoriaShown = false;
    this.isSubcategoriaShown = false;
    this.isComparativoShown = false;
    this.istraficoShown =false;
    
    var fecini = new Date(this.actInitDate.getFullYear(), this.actInitDate.getMonth(),1);
    var fecfin = new Date(this.actEndDate + 1);
    var antfecini = new Date(this.antInitDate.getFullYear(), this.antInitDate.getMonth(),1);
    var antfecfin = new Date(this.antEndDate+1);

   debugger;
    if(fecini >= fecfin){
      Swal.fire({
        icon: 'error',
        title: 'Verifique sus fechas',
        text: 'La fecha hasta, no puede ser mayor o igual a la fecha inicio'
      })

      this.spinner.hide();
      return false;
    }
    if((antfecini >= antfecfin)||(antfecini>=fecini)){
      
      Swal.fire({
        icon: 'error',
        title: 'Verifique sus fechas',
        text: 'La fecha anterior inicio, no puede ser mayor o igual a la fecha de inicio y tampoco a la fecha fin hasta'
      })

      this.spinner.hide();
      return false;
    }
    this.filtros = {
      Marca: this.marcasSelect,
      Edificio: this.buildsSelect,
      FechaInicioActual: fecini,      //new Date(this.actDateFrom.year,this.actDateFrom.month -1,this.actDateFrom.day),
      FechaFinActual:  fecfin,        //new Date(this.actDateTo.year,this.actDateTo.month -1,this.actDateTo.day),
      FechaInicioAnterior: antfecini, //new Date(this.antDateFrom.year,this.antDateFrom.month -1,this.antDateFrom.day),
      FechaFinAnterior: antfecfin,    //new Date(this.antDateTo.year,this.antDateTo.month -1,this.antDateTo.day),
      SubscripciónId:environment.userSubscripciónId,
      UserEmail: environment.userEmailLogged,
    }
    
    this.months = getSelectedMonths(this.filtros.FechaInicioActual,this.filtros.FechaFinActual);
          
    this.registroServicios.getResultCharts(this.filtros).subscribe(
      resolve => {
        this.result = resolve;
        if(this.result.datasetTable != null)
        {

          this.Cecos = Array.from(new Map(this.result.datasetTable.map((item: any) => [item["build"], item])).values());// [...new Map(this.result.datasetTable.map(item => [item[key], item])).values()];// [...new Set(this.result.datasetTable.map(item => item.build))];
          this.activeCeco = this.Cecos[0].build;
          this.sortedData = this.result.datasetTable;
          this.sortedDataCC = this.result.datasetTableCC;
          this.sortedDataMarca = this.result.datasetTableMarca;
          this.sortedDataCate = this.result.datasetTableCate;
          this.sortedDataSubCate = this.result.datasetTableSubCate;
          //this.dataSource.sort = this.sort;
          //this.dataset = this.result.datasetResumenVentas;
          this.KPIs = this.result.listKPIs;
          //this.changeChartValues();
          this.myChart.updateChart(1,this.result.datasetResumenVentas,this.result.labels);
          //this.myChartVariacion.updateChart(1,this.result.datasetVariacionVentasXTrafico,this.result.labels);
          this.myChartTicket.updateChart(1,this.result.datasetTicketAverage,this.result.labels);
          this.myChartCompliance.updateChart(1,this.result.datasetCumplimiento,this.result.labels);
          this.myChartTasa.updateChart(1,this.result.datasetTasa,this.result.labels);
          this.myChartVariacionFinal.updateChart(1,this.result.datasetVariacion,this.result.labels);

          //CARGA DE DATASETS

          this.changeChartValues(1);

          if(this.result.datasetTableCC.length>0){
            this.isCCShown = true;
          }

          if (this.result.datasetTableMarca.length > 0){
            this.isMarcaShown=true;
          }
      
          if (this.result.datasetTableCate.length > 0){
            this.isCategoriaShown = true;
          }

          if (this.result.datasetTableSubCate.length > 0){
            this.isSubcategoriaShown = true;
          }
          
          //aqui se inicia la carga de los datasets de trafico
          if(this.result.datasetVariacion.length > 0 && this.result.datasetVM2.length > 0 && this.result.datasetVariacionVentasXTrafico.length > 0){
            
            this.isComparativoShown=true;
          }
          
          if(this.result.datasetVariacionTraficoDiaXMes!=null)
          if(this.result.datasetVariacionTraficoDiaXMes.length > 0){
            this.myChartVariacionTrafico.updateChart(1,this.result.datasetVariacionTraficoDiaXMes,this.result.labels);
            this.istraficoShown=true;
          }

        sessionStorage.setItem('DSGeneralInfo', JSON.stringify(this.result.datasetTable));

        }else{
          this.defaultResult();
        }

        this.spinner.hide();
      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }

  filterByCecoPill(build) {


    this.reloadSelectionsTabs();

    var fecini = new Date(this.actInitDate.getFullYear(), this.actInitDate.getMonth(),1);
    var fecfin = new Date(this.actEndDate + 1);
    var antfecini = new Date(this.antInitDate.getFullYear(), this.antInitDate.getMonth(),1);
    var antfecfin = new Date(this.antEndDate+1);

    this.spinner.show();
    var cecos:string[] = [];
    if(build == "Todos"){
      cecos = this.Cecos.map(m => m.codigo)
    }else{
      cecos = this.Cecos.filter(x => x.nombre === build.build).map(m => m.codigo)
    }
    this.filtros = {
      Marca: this.marcasSelect,
      Edificio: [this.edificios.find(x => x.nombre === build.build).codigo],
      FechaInicioActual: fecini,      //new Date(this.actDateFrom.year,this.actDateFrom.month -1,this.actDateFrom.day),
      FechaFinActual:  fecfin,        //new Date(this.actDateTo.year,this.actDateTo.month -1,this.actDateTo.day),
      FechaInicioAnterior: antfecini, //new Date(this.antDateFrom.year,this.antDateFrom.month -1,this.antDateFrom.day),
      FechaFinAnterior: antfecfin,    //new Date(this.antDateTo.year,this.antDateTo.month -1,this.antDateTo.day),
      SubscripciónId:environment.userSubscripciónId,
      UserEmail: environment.userEmailLogged,
    }
    this.registroServicios.getResultCharts(this.filtros).subscribe(
      resolve => {
        this.result = resolve;
        if(this.result.datasetTable != null)
        {
          this.activeCeco = this.Cecos[0].build;

          if(sessionStorage.getItem('DSGeneralInfo')!=null){
            this.result.datasetTable= JSON.parse(sessionStorage.getItem('DSGeneralInfo'));
          }

          this.sortedData = this.result.datasetTable;
          this.sortedDataCC = this.result.datasetTableCC;
          this.sortedDataMarca = this.result.datasetTableMarca;
          this.sortedDataCate = this.result.datasetTableCate;
          this.sortedDataSubCate = this.result.datasetTableSubCate;
          //this.dataSource.sort = this.sort;
          //this.dataset = this.result.datasetResumenVentas;
          this.KPIs = this.result.listKPIs;
          //this.changeChartValues();
          this.myChart.updateChart(1,this.result.datasetResumenVentas,this.result.labels);
          //this.myChartVariacion.updateChart(1,this.result.datasetVariacionVentasXTrafico,this.result.labels);
          this.myChartTicket.updateChart(1,this.result.datasetTicketAverage,this.result.labels);
          this.myChartCompliance.updateChart(1,this.result.datasetCumplimiento,this.result.labels);
          this.myChartTasa.updateChart(1,this.result.datasetTasa,this.result.labels);
          this.myChartVariacionFinal.updateChart(1,this.result.datasetVariacion,this.result.labels);
          
          //AGREGAR ACA LOS DATASETS DE TRAFICO
          this.myChartVariacionTrafico.updateChart(1,this.result.datasetVariacionTraficoDiaXMes,this.result.labels);
          

          debugger;
        
        }else{
          this.defaultResult();
        }

        this.spinner.hide();
      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }

  changeChartValues(val)
  {
    if(val == 1)
    {
      this.myChart.updateChart(1,this.result.datasetResumenVentas,this.result.labels);
      this.titleMarcas = "Ventas Marca";
    }
    if(val == 2)
    {
      this.myChart.updateChart(1,this.result.datasetResumenVariacion,this.result.labels);
      this.titleMarcas = "Variación Marca";
    }
    if(val == 3)
    {
      this.myChart.updateChart(1,this.result.datasetResumenMT2,this.result.labels);
      this.titleMarcas = "V/M2 Marca";
    }
    if(val == 4)
    {
      this.myChart.updateChart(1,this.result.datasetResumenTasa,this.result.labels);
      this.titleMarcas = "Tasa Conversión";
    }

  }

  changeChartComparativo(val)
  {
    if(val == 1)
    {
      this.myChartVariacionFinal.updateChart(1,this.result.datasetVariacion,this.result.labels);
      this.titleComparativo = "% Variación"
    }
      
    if(val == 2)
    {
      this.myChartVariacionFinal.updateChart(1,this.result.datasetVM2,this.result.labels);
      this.titleComparativo = "V/M2 Marca (Periodo Actual)"
    }
    if(val == 3)
    {
      this.myChartVariacionFinal.updateChart(1,this.result.datasetVariacionVentasXTrafico,this.result.labels);
      this.titleComparativo = "Variación Ventas Marca vs Tráfico CC"
    }

  }

  changeChartTraficoSemanalXMeses(mes)
  {
    this.spinner.show();

    this.taficomesseleccionadosemanas=mes;

    this.filtros.FechaInicioActual = new Date(this.actInitDate.getFullYear(), getCodeMonth(mes)-1,1);
    this.filtros.FechaFinActual = new Date(this.actInitDate.getFullYear(), getCodeMonth(mes),0);
    this.filtros.FechaInicioAnterior =new Date(this.antInitDate.getFullYear(), getCodeMonth(mes)-1,1);
    this.filtros.FechaFinAnterior=new Date(this.antInitDate.getFullYear(), getCodeMonth(mes),0);
   
    this.registroServicios.getResultCharts(this.filtros).subscribe(

      resolve => {
        this.result = resolve;
        if(this.result.datasetTable != null)
        {
          debugger;
          if(this.result.datasetVariacionTraficoSemanalXMes!=null)
          if(this.result.datasetVariacionTraficoSemanalXMes.length > 0){
            this.istraficoShown=true;
            this.myChartVariacionTraficoSemanalMes.updateChart(1,this.result.datasetVariacionTraficoSemanalXMes,this.result.daysWeeklabels);
            this.titleVariacion = "Variación Semanal X mes";
          }

        }else{
          this.defaultResult();
        }

        this.spinner.hide();
      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );    
  }

  changeChartTraficoDiasXMeses(mes)
  {
    this.spinner.show();

    this.taficomesseleccionado=mes;

    this.filtros.FechaInicioActual = new Date(this.actInitDate.getFullYear(), getCodeMonth(mes)-1,1);
    this.filtros.FechaFinActual = new Date(this.actInitDate.getFullYear(), getCodeMonth(mes),0);
    this.filtros.FechaInicioAnterior =new Date(this.antInitDate.getFullYear(), getCodeMonth(mes)-1,1);
    this.filtros.FechaFinAnterior=new Date(this.antInitDate.getFullYear(), getCodeMonth(mes),0);
   
    this.registroServicios.getResultCharts(this.filtros).subscribe(

      resolve => {
        this.result = resolve;
        if(this.result.datasetTable != null)
        {
          debugger;
          if(this.result.datasetVariacionTraficoDiasXMes!=null)
          if(this.result.datasetVariacionTraficoDiasXMes.length > 0){
            this.istraficoShown=true;
            debugger;
            this.myChartVariacionTraficosdiasxmes.updateChart(1,this.result.datasetVariacionTraficoDiasXMes,this.result.daysMontlabels);
            this.titleVariacion = "Variación Días X Mes";
          }

        }else{
          this.defaultResult();
        }

        this.spinner.hide();
      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );

    debugger;

    
  }

  changeChartPesosTrafico_LV_SD_XMeses(mes)
  {
    this.spinner.show();
    this.taficomesseleccionado=mes;
    this.filtros.FechaInicioActual = new Date(this.actInitDate.getFullYear(), getCodeMonth(mes)-1,1);
    this.filtros.FechaFinActual = new Date(this.actInitDate.getFullYear(), getCodeMonth(mes),0);
    this.filtros.FechaInicioAnterior =new Date(this.antInitDate.getFullYear(), getCodeMonth(mes)-1,1);
    this.filtros.FechaFinAnterior=new Date(this.antInitDate.getFullYear(), getCodeMonth(mes),0);
    this.registroServicios.getResultCharts(this.filtros).subscribe(
      resolve => {
        this.result = resolve;
        if(this.result.datasetTable != null)
        {
          if(this.result.datasetPesoCCxSemanaFinSemanaXMes!=null)
          if(this.result.datasetPesoCCxSemanaFinSemanaXMes.length > 0){
            this.istraficoShown=true;
            this.mychartPesoTraficodiasxmes.updateChart(1, this.result.datasetPesoCCxSemanaFinSemanaXMes,this.result.pieLabels);
            
          }

        }else{
          this.defaultResult();
        }

        this.spinner.hide();
      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
    //Carga 
    this.changeChartPesosTraficoDiasSemanaXMeses(mes);
    this.changeChartPesosTraficoEntradaXMeses(mes);
  }

  changeChartPesosTraficoDiasSemanaXMeses(mes)
  {
    this.spinner.show();
    this.taficomesseleccionado=mes;
    this.filtros.FechaInicioActual = new Date(this.actInitDate.getFullYear(), getCodeMonth(mes)-1,1);
    this.filtros.FechaFinActual = new Date(this.actInitDate.getFullYear(), getCodeMonth(mes),0);
    this.filtros.FechaInicioAnterior =new Date(this.antInitDate.getFullYear(), getCodeMonth(mes)-1,1);
    this.filtros.FechaFinAnterior=new Date(this.antInitDate.getFullYear(), getCodeMonth(mes),0);
    this.registroServicios.getResultCharts(this.filtros).subscribe(
      resolve => {
        this.result = resolve;
        if(this.result.datasetTable != null)
        {
          if(this.result.datasetPesoGrupoSemanaXMes!=null)
          if(this.result.datasetPesoGrupoSemanaXMes.length > 0){
            this.istraficoShown=true;
            this.mychartPesoTraficosemanalxmes.updateChart(1, this.result.datasetPesoGrupoSemanaXMes,this.result.daysWeeklabels);
          }

        }else{
          this.defaultResult();
        }

        this.spinner.hide();
      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }

  changeChartPesosTraficoEntradaXMeses(mes)
  {
    this.spinner.show();
    this.taficomesseleccionado=mes;
    this.filtros.FechaInicioActual = new Date(this.actInitDate.getFullYear(), getCodeMonth(mes)-1,1);
    this.filtros.FechaFinActual = new Date(this.actInitDate.getFullYear(), getCodeMonth(mes),0);
    this.filtros.FechaInicioAnterior =new Date(this.antInitDate.getFullYear(), getCodeMonth(mes)-1,1);
    this.filtros.FechaFinAnterior=new Date(this.antInitDate.getFullYear(), getCodeMonth(mes),0);
    this.registroServicios.getResultCharts(this.filtros).subscribe(
      resolve => {
        this.result = resolve;
        if(this.result.datasetTable != null)
        {
          if(this.result.datasetPesoCCEntradasXMes!=null)
          if(this.result.datasetPesoCCEntradasXMes.length > 0){
            this.istraficoShown=true;
            debugger;
            this.mychartPesoCCEntradasXMes.updateChart(1, this.result.datasetPesoCCEntradasXMes,this.result.gateslabels);
          }
        }else{
          this.defaultResult();
        }

        this.spinner.hide();
      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }


  changeChartTrafico(val)
  {
    
    if(val == 1)
    {
      this.titleVariacion = "Variación Mes";
      this.getResults();
    }
      
    if(val == 2)
    {
      this.titleVariacion = "Variación Día Semana"
    }
    if(val == 3)
    {
      this.titleVariacion = "Variación Diaria"
    }
    if(val == 4)
    {
      this.titleVariacion = "Pesos"
    }
  }

  onSubmit(){

    this.reloadSelectionsTabs();

    this.getResults();
  }

  reloadSelectionsTabs(){

    this.titleMarcas = "Ventas Marca";

    const active =   this.blockTypeChart.nativeElement.getElementsByClassName("active");
    if(active!=null )
    if(active.length>0 ){
    
      active[0].classList.remove("focus");
      active[0].classList.remove("active"); 
    }
    
    //COMPARATIVO RESET SELECTIONS
    this.titleComparativo = "% Variación";
    const activeCom =   this.blockComparativoChart.nativeElement.getElementsByClassName("active");
    if(activeCom!=null)
     if(activeCom.length>0){
   
      activeCom[0].classList.remove("focus");
      activeCom[0].classList.remove("active");
      
    }


  }

  getMarcasConsulta(marcas: string[]) {
    this.spinner.show();
    this.registroServicios.obtenerMarcasIds(marcas).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.marcas = resolve.sort((a,b) => a.nombre.localeCompare(b.nombre));
          //this.marcasSelect = this.marcas.map(x=> x.codigo);
          //this.getResults();
          this.spinner.hide();
        }
      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }
  filterCeco(cecos,item) {
    
    //return [];
    if(cecos.length > 0)
    {
      return cecos.filter(x => x.build == item.build);
    }
  }
  sumarizeInfo(cecos, value)
  {
    var results = cecos.filter(x => x.build == value.build);
    var item = { 
      variSales: 0.00,
      vm2: 0.00,
      ticket: 0.00,
      lastSales: 0.00,
      currentSales: 0.00,
      budget: 0.00,
      compliance: 0.00,
      area: 0.00,
      bills: 0.00,
    }
    for (let i = 0; i < results.length; i++) {
      //item.variSales += cecos[i].variSales;
      //item.vm2 += cecos[i].vm2;
      //item.ticket += cecos[i].ticket;
      item.bills += cecos[i].bills;
      item.lastSales += cecos[i].lastSales;
      item.currentSales += cecos[i].currentSales;
      item.budget += cecos[i].budget;
      item.compliance += cecos[i].compliance;
      item.area += cecos[i].area;
    };
    item.variSales = isNaN((item.currentSales - item.lastSales) / item.lastSales) || ((item.currentSales - item.lastSales) / item.lastSales) == Infinity ? 0 : ((item.currentSales - item.lastSales) / item.lastSales) *100;
    item.vm2 = isNaN(item.currentSales / item.area) || (item.currentSales / item.area)  == Infinity ? 0 : item.currentSales / item.area;
    item.ticket = isNaN(item.currentSales / item.bills) || (item.currentSales / item.bills)  == Infinity  ? 0 : item.currentSales / item.bills;
    //item.variSales = (((item.currentSales - item.lastSales)) / item.lastSales) *100;
    return [item];
  }
  sumarizeComparative(data, value)
  {
    var results = data.filter(x => x.build == value.build);
    var item = { 
      salesC: 0.00,
      salesL: 0.00,
      area: 0.00,
      vm2: 0.00,
      variacion: 0.00,
    }
    for (let i = 0; i < results.length; i++) {
      item.salesC += data[i].salesC;
      item.salesL += data[i].salesL;
      item.area += data[i].area;
    };
    item.variacion =  isNaN((item.salesC - item.salesL) / item.salesL) || ((item.salesC - item.salesL) / item.salesL) == Infinity ? 0 : ((item.salesC - item.salesL) / item.salesL) *100;
    item.vm2 = isNaN(item.salesC / item.area) || (item.salesC / item.area) == Infinity ? 0 : item.salesC / item.area;
    
    return [item];
  }
  sortData(sort: Sort,value) {
    const data = this.result.datasetTable.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = this.result.datasetTable;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      //console.log(sort.active);
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'build': return compare(a.build, b.build, isAsc);
        case 'year': return compare(a.year, b.year, isAsc);
        case 'month': return compare(a.month, b.month, isAsc);
        case 'variSales': return compare(a.variSales, b.variSales, isAsc);
        case 'vm2': return compare(a.vm2, b.vm2, isAsc);
        case 'ticket': return compare(a.ticket, b.ticket, isAsc);
        // case 'area': return compare(a.area, b.area, isAsc);
        case 'lastSales': return compare(a.lastSales, b.lastSales, isAsc);
        case 'currentSales': return compare(a.currentSales, b.currentSales, isAsc);
        case 'budget': return compare(a.budget, b.budget, isAsc);
        case 'daysReported': return compare(a.daysReported, b.daysReported, isAsc);
        
        case 'compliance': return compare(a.compliance, b.compliance, isAsc);
        default: return 0;
      }
    });
    
  }
  sortComparativeData(sort: Sort, table) {
    var sortData:any = [];
    switch (table) {
      case 1:
        sortData = this.result.datasetTableCC.slice();    
        break;
      case 2:
        sortData = this.result.datasetTableMarca.slice();    
        break;
      case 3:
        sortData = this.result.datasetTableCate.slice();    
        break;
      case 4:
        sortData = this.result.datasetTableSubCate.slice();    
        break;
    
      default:
        break;
    }
    
    if (!sort.active || sort.direction === '') {
      switch (table) {
        case 1:
          sortData = this.result.datasetTableCC;    
          break;
        case 2:
          sortData = this.result.datasetTableMarca;    
          break;
        case 3:
          sortData = this.result.datasetTableCate;    
          break;
        case 4:
          sortData = this.result.datasetTableSubCate;    
          break;
      
        default:
          break;
      }
      return;
    }

    var dataSorted = sortData.sort((a, b) => {
      //console.log(sort.active);
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'year': return compare(a.year, b.year, isAsc);
        case 'month': return compare(a.month, b.month, isAsc);
        case 'variacion': return compare(a.variacion, b.variacion, isAsc);
        case 'vm2': return compare(a.vm2, b.vm2, isAsc);
        default: return 0;
      }
    });
    switch (table) {
      case 1:
        this.result.datasetTableCC = dataSorted;    
        break;
      case 2:
        this.result.datasetTableMarca = dataSorted;    
        break;
      case 3:
        this.result.datasetTableCate = dataSorted;    
        break;
      case 4:
        this.result.datasetTableSubCate = dataSorted;    
        break;
    
      default:
        break;
    }

  }
}

const getSelectedMonths = (
  startDate: Date,
  endDate: Date,
) => {
  const dates = [];
  const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio","Julio", "Agosto", "Septimbre", "Octubre", "Noviembre", "Diciembre"];
  var initmonth = startDate.getMonth();
  for(var i =0; i<=endDate.getMonth(); i++){
    dates.push(monthNames[i])
  }
  return dates;
};

const getCodeMonth=(
  mes: string,
)=>{
  switch (mes) {
    case 'Enero':
      return 1;
    case 'Febrero':
      return 2;
    case 'Marzo':
      return 3;
    case 'Abril':
      return 4;
    case 'Mayo':
      return 5;
    case 'Junio':
      return 6;
    case 'Julio':
      return 7;
    case 'Agosto':
      return 8;
    case 'Septiembre':
      return 9;
    case 'Octubre':
      return 10;
    case 'Noviembre':
      return 11;
    case 'Diciembre':
      return 12;
  }
};

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}